"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import BentoFeaturesGrid from "@/components/ui/BentoFeaturesGrid";
interface DebugBentoModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export default function DebugBentoModal(t0) {
  const $ = _c(15);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      zIndex: 50
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-black/60 backdrop-blur-sm" /></Transition.Child>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XMarkIcon className="size-5" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose) {
    t4 = <button onClick={onClose} className="absolute right-5 top-5 z-10 rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600" aria-label="Close">{t3}</button>;
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="border-b border-gray-100 px-8 py-5"><Dialog.Title className="text-lg font-semibold text-gray-900">Debug: Features Bento Grid</Dialog.Title></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="p-8"><BentoFeaturesGrid /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <div className="fixed inset-0 z-50 overflow-y-auto"><div className="flex min-h-full items-center justify-center p-4"><Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95 translate-y-4" enterTo="opacity-100 scale-100 translate-y-0" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100 translate-y-0" leaveTo="opacity-0 scale-95 translate-y-4"><Dialog.Panel className="relative w-full max-w-6xl overflow-hidden rounded-[20px] bg-white shadow-2xl max-h-[90vh] overflow-y-auto lg:max-h-none lg:overflow-visible">{t4}{t5}{t6}</Dialog.Panel></Transition.Child></div></div>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onClose || $[10] !== t7) {
    t8 = <Dialog className="relative" as="div" style={t1} onClose={onClose}>{t2}{t7}</Dialog>;
    $[9] = onClose;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpen || $[13] !== t8) {
    t9 = <Transition appear={true} show={isOpen}>{t8}</Transition>;
    $[12] = isOpen;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}